import React from 'react';

const IndustryAnalytics = () => {
  return (
    <iframe
      src="https://bicloud.krgsc.kz/public/dashboards/33"
      title="Industry Analytics"
      style={{ border: 'none' }}
      width="100%"
      height="100%"
    />
  );
};

export default IndustryAnalytics;
